import React from 'react';
import { Container, Typography, Box } from '@mui/material';

  const TermsConditions: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Conditions générales de vente
      </Typography>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          1. Champ d’application
        </Typography>
        <Typography variant="body1" paragraph>
          1.1 Les CGV s’appliquent, sans restriction ni réserve, à l’ensemble des ventes de
          produits (vêtements, accessoires, etc.) proposées par Bratan Family aux consommateurs via
          le Site. Toute commande passée sur le Site implique l’acceptation pleine et entière des
          présentes CGV par le client.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          2. Produits
        </Typography>
        <Typography variant="body1" paragraph>
          2.1 Les produits proposés à la vente sont décrits et présentés avec la plus grande
          précision possible (photos, descriptions, tailles, couleurs, compositions, etc.). Les
          photographies ont une valeur illustrative ; de légères différences de couleurs ou de
          rendu peuvent exister selon les écrans et les réglages.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          3. Prix
        </Typography>
        <Typography variant="body1" paragraph>
          3.1 Les prix sont indiqués en euros, toutes taxes comprises (TTC), hors frais de
          livraison. Les frais de livraison applicables sont précisés avant la validation
          définitive de la commande. Bratan Family se réserve le droit de modifier ses prix à tout
          moment, tout en appliquant le tarif en vigueur au moment de la validation de la
          commande.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          4. Commande, Promotion et compte client
        </Typography>
        <Typography variant="body1" paragraph>
          4.1 Pour passer commande, le Client peut choisir de créer un compte "personnel" ou de
          commander en tant "qu’invité" (sans compte). Lors de la création d’un compte, le Client
          s’engage à fournir des informations exactes, complètes et à les mettre à jour en cas de
          modification pour faciliter lors de l'achat.
        </Typography>
        <Typography variant="body1" paragraph>
          4.2 Toute commande passée sur le Site vaut acceptation pleine et entière du prix, des
          caractéristiques des produits sélectionnés ainsi que des présentes Conditions Générales de
          Vente. Une fois la commande confirmée, un e-mail récapitulatif est automatiquement envoyé
          à l’adresse électronique (mail) fournie lors du paiement. Toutes personnes ayant un
          compte client reçoivent également un récapitulatif de commandes sur la page client.
        </Typography>
        <Typography variant="body1" paragraph>
          4.3 Les Clients et les visiteurs du Site peuvent également bénéficier, à certaines
          périodes de l’année, d’offres spéciales ou de codes promotionnels saisonniers,
          accessibles directement via leur compte ou lors de leur visite sur le Site en pop up sur
          le haut de la page. Ces avantages ne sont pas systématiques et peuvent varier selon les
          périodes et la disponibilité.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          5. Paiement
        </Typography>
        <Typography variant="body1" paragraph>
          5.1 Le paiement des commandes s’effectue en ligne via un prestataire sécurisé (Stripe).
          Le Client garantit qu’il est autorisé à utiliser le moyen de paiement sélectionné et que
          celui-ci dispose des fonds nécessaires pour régler la commande.
        </Typography>
        <Typography variant="body1" paragraph>
          5.2 Le Site accepte plusieurs méthodes de paiement, notamment Visa, Mastercard,
          Bancontact, Revolut, ainsi que tout autre moyen proposé lors de la validation de la
          commande. Toutes les transactions sont protégées par un chiffrement SSL et respectent les
          normes de conformité PCI-DSS, garantissant ainsi la sécurité et la confidentialité des
          données bancaires. Seules des données techniques limitées, strictement nécessaires au
          traitement et au suivi des transactions, peuvent être conservées par le prestataire de
          paiement.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          6. Livraison
        </Typography>
        <Typography variant="body1" paragraph>
          6.1 Les livraisons sont organisées depuis la ville de Huy et sont limitées exclusivement
          au territoire belge et les villes sont délimités par des zones de livraisons. Aucune
          livraison n’est assurée à l’international. Trois zones ont été définies :
        </Typography>
        <Typography variant="body1" paragraph>
          6.2 Zone A – 0 à 5/7 km autour de Huy : Livraison gratuite. Délai estimé : 24 à 72
          heures. Livraison effectuée par nos propres livreurs, avec créneau horaire.
        </Typography>
        <Typography variant="body1" paragraph>
          6.3 Zone B – 5/7 km à 15 km autour de Huy : Délai estimé : 24 à 48 heures. Livraison
          effectuée par nos propres livreurs, avec créneau horaire.
        </Typography>
        <Typography variant="body1" paragraph>
          6.4 Zone C – Au-delà de 15 km (jusqu’à tout le territoire belge) : Livraison assurée
          uniquement par nos partenaires logistiques locaux (GLS, Mondial Relay, BPOST). Délai
          variable selon les transporteurs. Aucun créneau horaire personnalisé n’est proposé. Cette
          zone couvre toute la Belgique en dehors des zones A et B. Bratan Family ne pourra être
          tenue responsable d’un retard dû au transporteur dans la zone C.
        </Typography>
        <Typography variant="body1" paragraph>
          6.5 En zone A et B, toute absence lors du créneau choisi peut entraîner un report de
          livraison.
        </Typography>
        <Typography variant="body1" paragraph>
          6.6 Nous précisons que tout créneaux horaires et estimations de livraisons vous seront
          fournis par mail après vos commandes mis au panier. Lors de la commande, le client doit
          renseigner son adresse complète et exacte. Une fois l’adresse validée, notre système
          identifie automatiquement la zone de livraison correspondante (Zone A, B, C) en fonction
          de la localisation du domicile. Chaque zone comme préciser ci-dessus peut entraîner des
          délais, frais de livraison ou conditions spécifiques différentes.
        </Typography>
        <Typography variant="body1" paragraph>
          6.7 Si commande en point relais veillez a bien vérifier qu'il y est des points relais
          "Mondial relay" autour de chez vous car nous n'en tenons pas compte des retards de
          livraisons pour vos erreurs de commandes, veillez a bien appliquer vos choix
          sélectionnés.
        </Typography>
        <Typography variant="body1" paragraph>
          6.8 Le client est informé du montant total de la livraison ainsi que de la zone
          applicable avant la validation finale de la commande. En cas d’erreur dans l’adresse
          fournie par le client (numéro, rue, code postal, commune), BRATAN Family ne pourra pas
          être tenu responsable d’un retard, d’une impossibilité de livraison ou d’éventuels frais
          supplémentaires.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          7. Droit de rétractation et retour S.A.V
        </Typography>
        <Typography variant="body1" paragraph>
          7.1 Le client dispose d’un délai légal de 14 jours à compter de la réception de la
          commande pour exercer son droit de rétractation, sans devoir justifier de motif. Les
          articles doivent être renvoyés propres, non portés, non lavés, et dans leur emballage
          d’origine complet.
        </Typography>
        <Typography variant="body1" paragraph>
          7.2 Conditions de retour : Un retour est accepté uniquement si le client apporte une
          justification valable, accompagnée de preuves visuelles (photos, vidéos) démontrant
          clairement le motif du retour :
        </Typography>
        <Typography variant="body1" paragraph>
          - Erreur de taille de notre part BF
        </Typography>
        <Typography variant="body1" paragraph>
          - Produit non conforme
        </Typography>
        <Typography variant="body1" paragraph>
          - Défaut visible à la réception
        </Typography>
        <Typography variant="body1" paragraph>
          Attention, ce qui n'est pas acceptés comme justificatif de retour est :
        </Typography>
        <Typography variant="body1" paragraph>
          - Changement d'avis
        </Typography>
        <Typography variant="body1" paragraph>
          - Dégradations du produit pour fraude (sanctions)
        </Typography>
        <Typography variant="body1" paragraph>
          - Erreur de taille de la part du client (contacter le S.A.V sous frais de renvoi du
          produit)
        </Typography>
        <Typography variant="body1" paragraph>
          Nous précisons que tout nos produits sont contrôler soignées et pris en photos/vidéos
          avant l'envoi des colis.
        </Typography>
        <Typography variant="body1" paragraph>
          7.3 Procédure de retour :
        </Typography>
        <Typography variant="body1" paragraph>
          1. Le client doit contacter le Service Après-Vente via le formulaire de contact
          disponible sur le site.
        </Typography>
        <Typography variant="body1" paragraph>
          2. Après validation du dossier par le SAV, une étiquette de retour prépayée est envoyée
          au client.
        </Typography>
        <Typography variant="body1" paragraph>
          3. Le client imprime l’étiquette, la colle sur le colis, puis renvoie le produit à
          l’adresse indiquée par point relais.
        </Typography>
        <Typography variant="body1" paragraph>
          4. Le traitement diffère selon la zone géographique du client ; les instructions
          précises sont communiquées directement par le S.A.V au client.
        </Typography>
        <Typography variant="body1" paragraph>
          7.4 Frais de retour : Les frais de retour sont entièrement pris en charge par Bratan
          Family lorsque le retour est validé par le Service Après-Vente.
        </Typography>
        <Typography variant="body1" paragraph>
          Remboursement ou échange : Après réception et vérification du produit retourné : soit un
          échange est effectué (taille, modèle disponible), soit un remboursement est réalisé sur le
          moyen de paiement initial. Le traitement peut prendre quelques jours selon le flux
          logistique.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          8. Garanties légales
        </Typography>
        <Typography variant="body1" paragraph>
          8.1 Les produits vendus bénéficient de la garantie légale, couvrant les défauts de
          conformité ainsi que les défauts non détectables au moment de l’achat. En cas de produit
          défectueux ou non conforme, le client doit contacter le S.A.V dans les plus brefs délais,
          en fournissant une description précise du problème permettant d’illustrer le défaut.
        </Typography>
        <Typography variant="body1" paragraph>
          8.2 Ces informations permettront au Service Après-Vente d’analyser rapidement la
          situation et d’apporter une solution appropriée, conformément aux dispositions légales
          applicables (échange ou remboursement selon les cas).
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          9. Responsabilité
        </Typography>
        <Typography variant="body1" paragraph>
          9.1 BRATAN Family ne peut être tenu responsable des dommages résultant :
        </Typography>
        <Typography variant="body1" paragraph>
          • d’une mauvaise utilisation des produits ;
        </Typography>
        <Typography variant="body1" paragraph>
          • d’une inexécution ou d’une mauvaise exécution du contrat imputable au client ;
        </Typography>
        <Typography variant="body1" paragraph>
          • d’un événement imprévisible et insurmontable causé par un tiers ;
        </Typography>
        <Typography variant="body1" paragraph>
          • ou d’un cas de force majeure, tel que défini par la loi.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          10. Propriété intellectuelle
        </Typography>
        <Typography variant="body1" paragraph>
          10.1 L’ensemble des éléments présents sur le site BRATAN Family — notamment la marque,
          le logo, les designs, les textes, les images, les photographies, les vidéos, les
          illustrations, les graphismes, ainsi que toute autre création originale — est protégé par
          les droits de propriété intellectuelle en vigueur. Ces éléments sont la propriété
          exclusive de BRATAN Family ou font l’objet d’une autorisation d’utilisation spécifique.
        </Typography>
        <Typography variant="body1" paragraph>
          10.2 Toute reproduction, représentation, modification, diffusion, adaptation, traduction,
          exploitation commerciale ou non commerciale, totale ou partielle, de l’un quelconque de
          ces contenus sans l’autorisation écrite préalable de BRATAN Family est strictement
          interdite et pourra faire l’objet de poursuites. Le client s’engage à ne pas utiliser,
          copier ou exploiter les contenus du site d’une manière susceptible de porter atteinte aux
          droits de BRATAN Family.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          11. Données personnelles
        </Typography>
        <Typography variant="body1" paragraph>
          11.1 Les données personnelles collectées dans le cadre des commandes sont traitées
          conformément à la législation en vigueur et à la politique de confidentialité de BRATAN
          Family, disponible sur le site.
        </Typography>
        <Typography variant="body1" paragraph>
          11.2 Le client est invité à consulter cette politique pour connaître :
        </Typography>
        <Typography variant="body1" paragraph>
          • les types de données collectées (nom, adresse, email, numéro de téléphone, informations
          de paiement, etc.) ;
        </Typography>
        <Typography variant="body1" paragraph>
          • les finalités du traitement (gestion des commandes, livraison, communication
          commerciale, amélioration des services, etc.) ;
        </Typography>
        <Typography variant="body1" paragraph>
          • les droits du client (accès, rectification, suppression, opposition, limitation du
          traitement, portabilité des données) et les modalités pour les exercer ;
        </Typography>
        <Typography variant="body1" paragraph>
          • les mesures de sécurité mises en place pour protéger les données.
        </Typography>
        <Typography variant="body1" paragraph>
          11.3 En validant sa commande, le client accepte que ses données soient utilisées
          conformément à la politique de confidentialité.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          12. Droit applicable et règlement des litiges
        </Typography>
        <Typography variant="body1" paragraph>
          12.1 Les présentes Conditions Générales de Vente sont soumises au droit belge. En cas de
          litige relatif à l’interprétation, l’exécution ou la validité des présentes CGV, les
          parties s’engagent à chercher une solution amiable avant toute action judiciaire.
        </Typography>
        <Typography variant="body1" paragraph>
          12.2 À défaut d’accord amiable, les tribunaux belges compétents pourront être saisis,
          sans préjudice du droit applicable et des règles impératives en matière de protection du
          consommateur.
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsConditions;
